export default __webpack_public_path__ + "dbba4208bee3d97fc940f3a6d78535a7.png";